
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import 'react-day-picker/lib/style.css';
import { faPlusCircle, faExclamationTriangle, faUserTimes, faUserCheck, faEdit } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import { Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import UserService from '../Services/userService/userService';
import RolService from '../Services/rolService/rolService';
import Checkbox from '@material-ui/core/Checkbox';
import RolesType from '../utils/roles';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class User extends Component {
    constructor(props) {
        super();
        this.state = {
            UserData: { pending: false, value: [] },
            RolData: { pending: false, value: [] },
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            isActive: true,
            SelectEmail: "",
            SelectRoles: "",
            SelectResellerID: 0,
            modal: { warning: false, id: null, success: false, add: false },
            Button: <a className="btn btn-success">OK</a>,
            loading: true,
            Edit: false,
            showReseller: false,
            Filter: {
                FilterUserName: ""
            },
            isAutenticated: true
        };
        this.userNamValue = this.userNamValue.bind(this);
        this.toggleAdd = this.toggleAdd.bind(this);
        this.hanldeEmail = this.hanldeEmail.bind(this);
        this.handleRoles = this.handleRoles.bind(this);
        this.toggleWarning = this.toggleWarning.bind(this);
        this.hanldeActive = this.hanldeActive.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.hanldeReseller = this.hanldeReseller.bind(this);
    }
    wait = 0;
    componentDidMount() {
        this.getUser(this.state.page, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive);
    }
    hanldeKeyPress(e) {
        if (e.keyCode === 13) {
            this.getUser(1, 10, this.state.Filter.FilterUserName, this.state.isActive);
        }
    }
    getUser(page, maxPerPage, UserName, isActive) {
        this.setState({
            UserData: { pending: true, value: [] },
            totalCount: 0
        });
        var DataResult = UserService.getAllUsers(page, maxPerPage, UserName, isActive);
        var that = this;
        DataResult.then(function (data) {
            that.setState({
                UserData: { pending: false, value: data.data.Users },
                totalCount: parseInt(data.data.User_Total_Count, 10),
                page: data.data.npage
            });
        }).catch((error) => {

            that.setState({
                loading: false,
                UserData: { pennding: false, value: [] }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    toggleAdd() {
        this.setState({
            modal: { warning: false, success: false, add: !this.state.modal.add },
            SelectRoles: "0",
            Edit: false,
            SelectEmail: "",
            SelectResellerID: "",
            showReseller: false
        });
        this.getRoles();
    }
    toggleEdit(id) {
        var UserList = this.state.UserData.value;
        this.getRoles(() => {
            var RolList = this.state.RolData.value;
            var user = UserList.find(x => x.ID === id);
            var rol = RolList.find(c => c.NAME === user.ROLID[0])
            var showReseller = false;
            if (user.RESELLERID !== null) {
                showReseller = true;
            }
            this.setState({
                modal: { warning: false, success: false, add: !this.state.modal.add },
                SelectEmail: user.USERNAME,
                SelectRoles: rol.ID,
                SelectResellerID: user.RESELLERID,
                Edit: true,
                showReseller: showReseller
            }, () => console.log());
        });
    }
    getRoles(callback) {
        var DataResult = RolService.getAllRoles();
        var that = this;
        DataResult.then(function (data) {
            that.setState({
                RolData: { pending: false, value: data.data }
            }, callback);
        })
    }
    userNamValue(e) {
        e.preventDefault();
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterUserName = e.target.value;
        this.setState(stateCopy);
    }
    setOperation(a, id, operations) {

        if (operations === "ADD") {
            this.setState({
                loading: false
            });
            this.toggleAdd();
        } else if (operations === "DELETE") {
            this.setState({
                loading: false
            });
            this.toggleWarning(id);
        } else if (operations === "EDIT") {
            this.setState({
                loading: false
            });
            this.toggleEdit(id);
        }
    }
    toggleWarning(id) {
        this.setState({
            modal: { warning: !this.state.modal.warning, id: id, success: false, add: false },
            Edit: false
        });
    }
    SaveUser(e) {
        e.preventDefault();
        var that = this;
        var UserName = this.state.SelectEmail ? this.state.SelectEmail : null;
        var RolList = this.state.SelectRoles ? this.state.SelectRoles : null;
        var Reseller = this.state.SelectResellerID ? this.state.SelectResellerID : null;
        var Email = sessionStorage.getItem('email');
        var Edit = this.state.Edit;
        var rol_list = this.state.RolData.value;
        var rol = rol_list.find(x => x.ID === RolList);
        this.setState({
            loading: true
        });
        if (RolList !== "0" && rol.NAME === "Reseller_Support" && Reseller === null) {
            toast.error("Reseller field should not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            this.setState({
                loading: false
            });
            return false;
        }
        if (!UserName || !RolList || RolList === "0") {
            toast.error("Email and Rol field should not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            this.setState({
                loading: false
            });
        } else {
            if (Edit) {

                if (rol.NAME !== "Reseller_Support")
                    Reseller = null;
                var DataResult = UserService.EditUser(this.state.SelectEmail, this.state.SelectRoles, Reseller, Email);
                DataResult.then(function (data) {
                    if (data.data === "OK") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            Edit: false,
                            showReseller: false,
                        });
                        toast.success("User Saved!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        that.getUser(1, 10, "", true);
                    } else if (data.data === "NoExist") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            Edit: false,
                            showReseller: false
                        });
                        toast.error("User dosen't Exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        //that.getUser(1, 10, "", true);         
                    } else if (data.data === "No") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            Edit: false,
                            showReseller: false
                        });
                        toast.error("User Not Saved!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        //that.getUser(1, 10, "", true); 
                    } else if (data.data === "NoRol") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            Edit: false,
                            showReseller: false
                        });
                        toast.error("Rol dosen't Exist.User not Saved!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        //that.getUser(1, 10, "", true); 
                    }
                }).catch((error) => {
                    that.setState({
                        loading: false,
                        UserData: { pennding: false, value: [] },
                        SelectRoles: "0",
                        SelectEmail: "",
                        SelectResellerID: "",
                        modal: { add: false },
                        Edit: false,
                        showReseller: false
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            } else {
                var DataResult1 = UserService.SaveUser(this.state.SelectEmail, this.state.SelectRoles, Reseller, Email);
                DataResult1.then(function (data) {
                    if (data.data === "OK") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            showReseller: false
                        });
                        toast.success("User Saved!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        that.getUser(1, 10, "", true);
                    } else if (data.data === "Exist") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            showReseller: false
                        });
                        toast.error("User already Exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        that.getUser(1, 10, "", true);
                    } else if (data.data === "No") {
                        that.setState({
                            loading: false,
                            UserData: { pennding: false, value: [] },
                            SelectRoles: "0",
                            SelectEmail: "",
                            SelectResellerID: "",
                            modal: { add: false },
                            showReseller: false
                        });
                        toast.error("User Not Saved!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                        that.getUser(1, 10, "", true);
                    }
                }).catch((error) => {
                    that.setState({
                        loading: false,
                        UserData: { pennding: false, value: [] },
                        SelectRoles: "0",
                        SelectEmail: "",
                        SelectResellerID: "",
                        modal: { add: false },
                        showReseller: false
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }
    DeleteUser(e) {

        var ID = this.state.modal.id;
        var Email = sessionStorage.getItem('email');
        var temp = this.state.isActive;
        var message = "";
        if (temp === true)
            message = "User Deactivated";
        else
            message = "User Activated";

        var result = UserService.DeleteUser(ID, Email);
        var that = this;
        that.setState({
            loading: true
        });
        result.then(function (data) {
            if (data.data === "OK") {
                that.setState({
                    modal: { success: false, id: null, add: false, warning: false },
                    loading: false,
                    isActive: true
                });
                that.getUser(1, 10, "", true);
                toast.success(message, {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "Empty") {
                that.setState({
                    modal: { success: false, id: null, add: false, warning: false },
                    loading: false
                });
                //that.SearchCompanyVersion();
                toast.error("User Not Exist!", {
                    className: {
                        opacity: 0.8
                    }
                });
            } else if (data.data === "No") {

                that.setState({
                    modal: { success: false, id: null, warning: false },
                    loading: false
                });
                toast.error("Operations Error!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {
            that.setState({
                loading: false,
                modal: { warning: false }
            });
            if (error.response) {
                if (error && error.response && error.response.data.Message === "500") {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error && error.response && error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        })
                }
            } else {
                toast.error("Code Error", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        });
    }
    handleRoles(event) {
        var value = event.target.value;
        var showReseller = false;

        if (value !== "0") {
            var rol_list = this.state.RolData.value;
            var rol = rol_list.find(x => x.ID === value);

            if (value !== 0 && rol.NAME === "Reseller_Support") {
                showReseller = true;
            }
        }
        this.setState({
            SelectRoles: value,
            showReseller: showReseller
        });
    }
    hanldeEmail(event) {
        var value = event.target.value;
        this.setState({
            SelectEmail: value
        });
    }
    hanldeReseller(event) {
        var value = event.target.value;
        this.setState({
            SelectResellerID: value
        });
    }
    hanldeActive(e) {
        var username = this.state.Filter.FilterUserName;
        var checked = e.target.checked;
        this.setState({
            isActive: checked
        }, () => {
            if (checked) {
                this.setState({
                    FilterUserName: username
                }, () => this.getUser(this.state.page, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive));
            } else {
                this.setState({
                    FilterUserName: username
                }, () => this.getUser(this.state.page, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive));
            }
        });
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if (parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    renderPages() {
        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getUser(i, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUser(next_page, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUser(pagesCount, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUser(1, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getUser(1, this.state.maxPerPage, this.state.Filter.FilterUserName, this.state.isActive)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }

    renderUserRow() {
        let dataResult = RolesType;
        var temp = Object.keys(dataResult);
        if (sessionStorage.getItem("rol") === temp[0]) {
            return (<div>
                <div className="row">
                    <div className="col s12">
                        <div className="card Logs">
                            <div className="card-header">
                                <div className="row" id="timelogs_filter">
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>User Name</label>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                            <input className="form-control" name="companycode" id="companycode" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.userNamValue} value={this.state.Filter.FilterUserName} />
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Active</label>
                                        <Checkbox
                                            style={{ width: 25, height: 25 }}
                                            checked={this.state.isActive}
                                            onChange={this.hanldeActive}
                                            color="primary"
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3">
                                        <div className="form-group">
                                            <a className="btn btn-success" style={{ 'padding': '0.6rem 1.14rem' }} onClick={(e) => this.setOperation(e, "", 'ADD')}><FontAwesomeIcon icon={faPlusCircle} />&nbsp;&nbsp;Create</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover table-striped table-sm myTable">
                                    <thead>
                                        <tr>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>User</th>
                                            <th scope="col" style={{ 'fontWeight': 'bold' }}>Rol</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.UserData.value.length > 0
                                                ?
                                                this.state.UserData.value.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.USERNAME}</td>
                                                        <td style={{ 'fontWeight': 'normal' }}>{item.ROLID}</td>
                                                        <td>
                                                        </td>
                                                        <td>
                                                            {
                                                                item.isActive
                                                                    ? <h6>
                                                                        <a title="Edit User" onClick={(e) => { this.setOperation(e, item.ID, "EDIT") }}><Badge color="warning"><FontAwesomeIcon icon={faEdit} /></Badge></a>&nbsp;&nbsp;
                                                                <a title="Delete User" onClick={(e) => { this.setOperation(e, item.ID, "DELETE") }}><Badge color="danger"><FontAwesomeIcon icon={faUserTimes} /></Badge></a>
                                                                    </h6>
                                                                    :
                                                                    <h6>
                                                                        <a title="Activate User" onClick={(e) => { this.setOperation(e, item.ID, "DELETE") }}><Badge color="success"><FontAwesomeIcon icon={faUserCheck} /></Badge></a>
                                                                    </h6>
                                                            }
                                                        </td>
                                                    </tr>;
                                                })
                                                :
                                                <tr><td colSpan="13"><div style={{ 'textAlign': 'center', 'fontWeight': 'normal' }}>No records.</div></td></tr>
                                        }
                                    </tbody>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        {this.renderFirstPage()}
                                        {this.renderPages()}
                                        {this.renderNextPage()}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
        } else {
            return (<Redirect to={'/login'} />)
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsRoles = this.state.RolData.value.map((item, index) => {
            return <option key={item.ID} className="dropdown-item" href="#" value={item.ID}>{item.NAME}</option>
        });

        return (
            <div>
                <BlockUi tag="div" blocking={this.state.UserData.pending} loader={<div className="loader"></div>} >
                    <MainLayout />
                    <div className="container"><ToastContainer hideProgressBar />

                        {
                            this.renderUserRow()
                        }
                        <Modal isOpen={this.state.modal.add} toggle={this.toggleAdd}
                            aria-labelledby="contained-modal-title-lg"
                            className={"modal-dialog modal-notify modal-success"}
                        >
                            <ModalHeader toggle={this.toggle}> <p className="heading lead">ADD</p>
                            </ModalHeader>
                            <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                                <div className="row" >
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Email</label>
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-sm-8">
                                        <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                            <input className="form-control" name="SelectEmail" id="SelectEmailv" type="text" onChange={this.hanldeEmail} value={this.state.SelectEmail} disabled={this.state.Edit} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" >
                                    <div className="col-lg-2 col-md-2 col-sm-2">
                                        <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Rol</label>
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-sm-8">
                                        <select className="form-control" onChange={this.handleRoles} value={this.state.SelectRoles}>
                                            <option className="dropdown-item" href="#" value="0" >Select</option>
                                            {optionItemsRoles}
                                        </select>
                                    </div>
                                </div>
                                {
                                    this.state.showReseller
                                        ? <div className="row" >
                                            <div className="col-lg-2 col-md-2 col-sm-2">
                                                <label className="control-label" style={{ 'paddingTop': '15px', 'float': 'right', 'fontWeight': 'bold' }}>Reseller</label>
                                            </div>
                                            <div className="col-lg-8 col-md-8 col-sm-8">
                                                <div className="form-group" style={{ 'paddingTop': '7px' }}>
                                                    <input className="form-control" name="SelectResellerID" id="SelectResellerID" type="number" onChange={this.hanldeReseller} value={this.state.SelectResellerID ? this.state.SelectResellerID : 0} />
                                                </div>
                                            </div>
                                        </div>
                                        : <div></div>
                                }

                            </ModalBody>
                            <ModalFooter className={"modal-footer justify-content-right"}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#00C851'}
                                    loading={this.state.loading}
                                />
                                {
                                    this.state.loading
                                        ? <div><a className="btn btn-success disabled" onClick={(e) => { this.SaveUser(e) }} disabled>OK</a>
                                            <a className="btn btn-outline-success waves-effect disabled" onClick={this.toggleAdd} disabled>CLOSE</a>
                                        </div>
                                        : <div><a className="btn btn-success" onClick={(e) => { this.SaveUser(e) }} >OK</a>
                                            <a className="btn btn-outline-success waves-effect" onClick={this.toggleAdd} >CLOSE</a>
                                        </div>
                                }

                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={this.state.modal.warning} toggle={this.toggleWarning}
                            aria-labelledby="contained-modal-title-lg"
                            className={"modal-dialog modal-notify modal-warning"}
                        >
                            <ModalHeader toggle={this.toggle}> <p className="heading lead">Warning</p>
                            </ModalHeader>
                            <ModalBody className={"text-center"} style={{ 'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto' }}>
                                <p><FontAwesomeIcon color="#FFBB33" icon={faExclamationTriangle} size="3x" /></p>
                                <p>Are you sure?</p>
                            </ModalBody>
                            <ModalFooter className={"modal-footer justify-content-right"}>
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#FF8800'}
                                    loading={this.state.loading}
                                />

                                {
                                    this.state.loading
                                        ? <div><a className="btn btn-warning disabled" onClick={(e) => { this.DeleteUser(e) }} disabled>OK</a>
                                            <a className="btn btn-outline-warning waves-effect disabled" onClick={this.toggleWarning} disabled>CLOSE</a>
                                        </div>
                                        : <div><a className="btn btn-warning" onClick={(e) => { this.DeleteUser(e) }} >OK</a>
                                            <a className="btn btn-outline-warning waves-effect" onClick={this.toggleWarning} >CLOSE</a>
                                        </div>

                                }
                            </ModalFooter>
                        </Modal>
                    </div>
                </BlockUi>
            </div>
        );
    }
}
export default User;


// WEBPACK FOOTER //
// ./src/user/user.jsx